import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from '../ui/ScrollReveal';
import { CTAButton } from '../ui/CTAButton';
import { CheckCircleIcon, ZapIcon, DownloadIcon } from 'lucide-react';
import { useCurrencyByIP } from '../../hooks/useCurrencyByIP';
const checklistItems = [{
  title: '200 ganchos virales en Español MX',
  desc: 'Diseñados específicamente para creadores en México.'
}, {
  title: 'Hooks para vender productos',
  desc: 'Convierte tus videos en ventas.'
}, {
  title: 'Hooks para crecer seguidores',
  desc: 'Optimiza retención y alcance.'
}, {
  title: 'Hooks para Reels, TikTok e Instagram',
  desc: 'Funciona en todas las plataformas.'
}, {
  title: 'Mini guía estratégica incluida',
  desc: 'Aprende cuándo usar cada tipo de gancho.'
}, {
  title: 'Acceso inmediato y de por vida',
  desc: 'Descarga instantánea después de comprar.'
}];
function ProductMockup() {
  return <div className="relative flex items-center justify-center" data-id="element-495">
      {/* Glow */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(255,107,0,0.12) 0%, transparent 65%)',
      filter: 'blur(40px)'
    }} data-id="element-496" />
      <div className="relative w-[200px] h-[280px] md:w-[240px] md:h-[340px]" style={{
      transform: 'rotateY(-5deg) rotateX(2deg)',
      transformStyle: 'preserve-3d'
    }} data-id="element-497">
        {/* Spine */}
        <div className="absolute -left-1.5 top-2 bottom-2 w-3 rounded-l-sm" style={{
        background: 'linear-gradient(to right, rgba(0,0,0,0.5), rgba(0,0,0,0.05))'
      }} data-id="element-498" />
        {/* Cover */}
        <div className="relative w-full h-full rounded-xl overflow-hidden border border-white/10 shadow-2xl shadow-black/50" data-id="element-499">
          <div className="absolute inset-0" style={{
          background: 'linear-gradient(145deg, #18181B 0%, #09090B 50%, #1a0f00 100%)'
        }} data-id="element-500" />
          {/* Accent border */}
          <div className="absolute inset-0 rounded-xl" style={{
          background: 'linear-gradient(135deg, rgba(255,107,0,0.25) 0%, rgba(251,191,36,0.15) 100%)',
          mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          maskComposite: 'exclude',
          WebkitMaskComposite: 'xor',
          padding: '1.5px'
        }} data-id="element-501" />
          <div className="relative h-full flex flex-col items-center justify-between p-5 md:p-7" data-id="element-502">
            <div className="flex items-center gap-1.5 bg-accent/15 border border-accent/30 rounded-full px-2.5 py-0.5" data-id="element-503">
              <ZapIcon className="w-2.5 h-2.5 text-accent" data-id="element-504" />
              <span className="text-[9px] font-bold text-accent tracking-wider uppercase" data-id="element-505">
                Meta Reels
              </span>
            </div>
            <div className="text-center space-y-2" data-id="element-506">
              <div className="mx-auto w-10 h-10 rounded-xl bg-accent/10 border border-accent/20 flex items-center justify-center" data-id="element-507">
                <ZapIcon className="w-5 h-5 text-accent" data-id="element-508" />
              </div>
              <div data-id="element-509">
                <p className="text-base font-extrabold text-white tracking-tight leading-tight" data-id="element-510">
                  HOOK
                </p>
                <p className="text-base font-extrabold text-accent tracking-tight leading-tight" data-id="element-511">
                  ARSENAL
                </p>
              </div>
              <div className="h-px w-10 mx-auto bg-gradient-to-r from-transparent via-accent/50 to-transparent" data-id="element-512" />
              <p className="text-[10px] font-bold text-neutral-400 tracking-widest uppercase" data-id="element-513">
                200 Ganchos
              </p>
            </div>
            <p className="text-[8px] font-semibold text-neutral-500 uppercase tracking-widest" data-id="element-514">
              PDF Digital
            </p>
          </div>
        </div>
        {/* Page edges */}
        <div className="absolute top-3 -right-1 bottom-3 w-1 rounded-r-sm" style={{
        background: 'repeating-linear-gradient(to bottom, #27272A 0px, #27272A 2px, #1a1a1d 2px, #1a1a1d 4px)'
      }} data-id="element-515" />
      </div>
    </div>;
}
export function WhatsIncludedSection() {
  const {
    price,
    originalPrice,
    isLoading
  } = useCurrencyByIP();
  return <section className="w-full py-20 md:py-32 px-4 md:px-5" data-id="element-516">
      <div className="max-w-4xl mx-auto" data-id="element-517">
        {/* Header */}
        <ScrollReveal data-id="element-518">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight text-center mb-3" data-id="element-519">
            Esto es lo que obtienes con{' '}
            <span className="text-accent" data-id="element-520">Hook Arsenal</span>
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={0.06} data-id="element-521">
          <p className="text-lg md:text-xl text-neutral-400 text-center mb-14 md:mb-16 max-w-2xl mx-auto" data-id="element-522">
            Todo listo para copiar, pegar y usar inmediatamente.
          </p>
        </ScrollReveal>

        {/* Two-column: checklist + mockup */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-center" data-id="element-523">
          {/* Checklist */}
          <div className="md:col-span-7 space-y-5" data-id="element-524">
            {checklistItems.map((item, i) => <ScrollReveal key={i} delay={0.05 + i * 0.06} data-id="element-525">
                <div className="flex gap-4 items-start" data-id="element-526">
                  <CheckCircleIcon className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" data-id="element-527" />
                  <div data-id="element-528">
                    <p className="text-white font-bold leading-snug" data-id="element-529">
                      {item.title}
                    </p>
                    <p className="text-sm text-neutral-400 mt-0.5" data-id="element-530">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>

          {/* Mockup */}
          <div className="md:col-span-5 flex justify-center" data-id="element-531">
            <ScrollReveal delay={0.2} data-id="element-532">
              <ProductMockup data-id="element-533" />
            </ScrollReveal>
          </div>
        </div>

        {/* Value box */}
        <ScrollReveal delay={0.35} data-id="element-534">
          <div className="mt-14 md:mt-20 max-w-lg mx-auto" data-id="element-535">
            <div className="relative bg-surface border border-accent/20 rounded-2xl p-6 md:p-8 text-center overflow-hidden" data-id="element-536">
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'radial-gradient(ellipse at top center, rgba(255,107,0,0.05) 0%, transparent 60%)'
            }} data-id="element-537" />
              <div className="relative" data-id="element-538">
                <div className="mb-2" data-id="element-539">
                  <span className="text-neutral-400 text-sm mr-2" data-id="element-540">Antes:</span>
                  <span className="text-xl text-neutral-400 line-through font-bold" data-id="element-541">
                    {originalPrice}
                  </span>
                </div>
                <div className="flex items-center justify-center gap-2 mb-1" data-id="element-542">
                  <span className="text-sm text-accent font-semibold" data-id="element-543">
                    🔥 Super Promo:
                  </span>
                  <span className={`text-4xl md:text-5xl font-extrabold text-accent transition-opacity duration-300 ${isLoading ? 'opacity-50' : 'opacity-100'}`} data-id="element-544">
                    {price}
                  </span>
                </div>
                <p className="text-xs text-amber-400/70 font-medium mb-6" data-id="element-545">
                  Solo por esta semana. Pago único. Sin suscripciones.
                </p>

                <CTAButton className="mx-auto text-lg md:text-xl py-5 px-10" data-id="element-546">
                  Descargar ahora — {price}
                </CTAButton>

                <div className="flex items-center justify-center gap-1.5 mt-4 text-neutral-500 text-xs" data-id="element-547">
                  <DownloadIcon className="w-3.5 h-3.5" data-id="element-548" />
                  <span data-id="element-549">Acceso inmediato</span>
                </div>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}